import React from 'react'
import { Popover } from 'antd';
import LineitemBox from '../LineitemBox';

const PopOver = ({ lineitems }) => {

  const list = lineitems.map((l, i) => <LineitemBox key={i} lineitem={l} width="300px"/>);
  const count = lineitems.length
  const content = (
    <div>
      <button className="axiom-button-button-icon round">
        {count}
      </button> 
      Associated line items
      <div className="popovers">
        {list}
      </div>
    </div>
  );

  return (
    <Popover content={content} placement="leftTop">
      <button className="axiom-button-button-icon round">
        {count}
      </button>
    </Popover>
  )
}

PopOver.defaultProps = {
  lineitem: {},
}

export default PopOver